import {optimizationCardSchema} from '../../../../../schemas/optimizationCardSchema';
import {z} from 'zod';
import {DTOptimizationNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {NodeType, OutputType} from 'common/src/modules/nodes/nodes.types';
import {
  OptimizeAcrossValue,
  OptimizeByName,
  OptimizeAcrossName,
  OptimizeByValue,
} from 'common/src/modules/optimization/optimization.types';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';
import {DEFAULT_DROP_CONDITIONS} from 'common/src/modules/optimization/optimization.consts';
import {NO_NODE_ID} from 'common/src/components/CLCardsMap/CLCardsMap.config';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';

export function convertOptimizationAICardToAPICard(
  optimizationCard: z.input<typeof optimizationCardSchema>,
  existingCard: DTOptimizationNode,
): DTOptimizationNode {
  const optimizeBy =
    getMatchingEnumValue(
      OptimizeByName,
      OptimizeByValue,
      optimizationCard.configuration.optimizeBy,
    ) || OptimizeByValue.Clicks;
  const optimizeGroup =
    getMatchingEnumValue(
      OptimizeAcrossName,
      OptimizeAcrossValue,
      optimizationCard.configuration.optimizeGroup,
    ) || OptimizeAcrossValue.Campaign;

  return {
    ...getAICardBaseDetails(optimizationCard),
    ...optimizationCard,
    type: NodeType.GENERAL_OPTIMIZATION,
    outputs: optimizationCard.outputs.map((output, index) => ({
      nodeId: existingCard?.outputs?.[index]?.nodeId ?? NO_NODE_ID,
      id: index + 1,
      name: output.name ?? `Output ${index + 1}`,
      type: OutputType.Regular,
    })),
    inputs: [],
    configuration: {
      optimizeBy,
      optimizeGroup,
      areAllAttributionSignalsSelected: true,
      areAllConversionTypesSelected: true,
      attributionSignalIds: [],
      conversionTypes: [],
      entitiesToShowGoal: 1,
      postOptimizationServingCoefficient: 1,
      dropConditions: DEFAULT_DROP_CONDITIONS,
    },
    variationsCount: optimizationCard.variationsCount,
  } as DTOptimizationNode;
}
